/**
 * Esprima Studios — Final-Sale Notes
 * ----------------------------------
 * Shows the "Made for you alone" final-sale note while the customer has
 * custom engraving (#engraving-toggle) or a stone request (#stone-toggle)
 * switched on, and adds a "Final sale" line-item property to the cart line
 * whenever a final-sale trigger applies (including tagged special orders).
 *
 * Works alongside engraving-options.js and stone-options.js without
 * changing them: it listens for their toggles and re-checks whenever those
 * modules re-render on a variant change.
 *
 * Depends on: snippets/final-sale-notes.liquid, final-sale-notes.css
 */
(function () {
  "use strict";

  var TEXT = {
    engraving: "With custom engraving, this piece is crafted for you, so it’s final sale.",
    stone: "With a stone chosen for you, this piece is crafted to your request, so it’s final sale.",
    both: "With your engraving and stone choice, this piece is crafted for you, so it’s final sale."
  };

  function init() {
    var root = document.querySelector("[data-final-sale-notes]");
    if (!root) return;

    var dynamicNote = root.querySelector("[data-final-sale-dynamic]");
    var dynamicText = root.querySelector("[data-final-sale-text]");
    var isSpecialOrder = root.getAttribute("data-special-order") === "true";

    // Same form-resolution logic as engraving-options.js / stone-options.js,
    // so all three modules attach their properties to the same cart form.
    var form = root.closest("form") || document.querySelector('form[action*="/cart/add"]');
    var propInput = null;
    if (form) {
      var formId = form.getAttribute("id");
      if (!formId) {
        formId = "esprima-options-form-" + Math.random().toString(36).slice(2);
        form.setAttribute("id", formId);
      }
      propInput = document.createElement("input");
      propInput.type = "hidden";
      propInput.name = "properties[Final sale]";
      propInput.disabled = true;
      propInput.setAttribute("form", formId);
      root.appendChild(propInput);
    }

    function isOn(id) {
      var el = document.getElementById(id);
      return !!(el && el.checked);
    }

    function update() {
      var engraving = isOn("engraving-toggle");
      var stone = isOn("stone-toggle");

      var key = engraving && stone ? "both" : engraving ? "engraving" : stone ? "stone" : null;
      if (dynamicNote) {
        dynamicNote.hidden = !key;
        if (key && dynamicText) dynamicText.textContent = TEXT[key];
      }

      if (propInput) {
        var reasons = [];
        if (isSpecialOrder) reasons.push("special order");
        if (engraving) reasons.push("engraved");
        if (stone) reasons.push("stone request");
        propInput.disabled = reasons.length === 0;
        propInput.value = reasons.length ? "Yes — " + reasons.join(", ") : "";
      }
    }

    // Toggle changes (delegated, so it survives module re-renders).
    document.addEventListener("change", function (e) {
      var t = e.target;
      if (t && (t.id === "engraving-toggle" || t.id === "stone-toggle")) update();
    });

    // The engraving/stone modules rebuild their markup on variant change,
    // which resets their toggles. Re-check whenever they re-render.
    if (window.MutationObserver) {
      ["engraving-options", "stone-options"].forEach(function (id) {
        var el = document.getElementById(id);
        if (el) new MutationObserver(update).observe(el, { childList: true });
      });
    }

    update();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
